import React, { useState } from 'react';
import RoomList from './RoomList';
import FloorMap from './FloorMap';
import Dropdown from "./BootstrapDropdown";

const FLOOR_OPTIONS = [
    { value: 0, label: '請選擇' },
    { value: 1, label: '1 樓' },
    { value: 2, label: '2 樓' },
    { value: 3, label: '3 樓' },
    { value: 4, label: '4 樓' },
];

const VIEW_OPTIONS = [
    { value: "roomList", label: "感測器列表" },
    { value: "floorMap", label: "樓層平面圖" },
];

const FloorSelector = () => {
    const [selectedFloor, setSelectedFloor] = useState(0);
    const [selectedView, setSelectedView] = useState('roomList');

    const handleFloorChange = (value) => {
        setSelectedFloor(parseInt(value, 10));
    };

    const handleViewChange = (value) => {
        setSelectedView(value);
        if (value === "floorMap" && selectedFloor === 0) {
            setSelectedFloor(1);
        } else if (value === "roomList") {
            setSelectedFloor(0);
        }
    };

    return (
        <div className="room-list__wrapper">
            <div className="room-list__selected_wrapper">
                <div className="room-list__selected">
                    <Dropdown
                        options={VIEW_OPTIONS}
                        selected={selectedView}
                        onSelect={handleViewChange}
                    />
                </div>
                <div className="room-list__selected">
                    <Dropdown
                        options={FLOOR_OPTIONS}
                        selected={selectedFloor}
                        onSelect={handleFloorChange}
                    />
                </div>
            </div>

            <div style={{ marginTop: '20px' }}>
                {selectedView === 'roomList'
                    ? <RoomList floor={selectedFloor} />
                    : <FloorMap floor={selectedFloor} />
                }
            </div>
        </div>
    );
};

export default FloorSelector;
